export default __webpack_public_path__ + "static/media/ragdoll7L.4a5af517.webp";